import isNumber from 'lodash/isNumber';
import { useCallback } from 'react';

import { useRefreshAnalyticsPeriod } from 'applications/GSP/app/providers/AnalyticsProvider/hooks/useRefreshAnalyticsPeriod';
import { analyticsActions } from 'applications/GSP/app/providers/AnalyticsProvider/store';
import {
  useAppDispatch,
  useAppSelector,
} from 'applications/GSP/shared/hooks/store';
import { getMillisecondsFromDays } from 'shared/utils/date';

export const useRefreshAnalytics = () => {
  const dispatch = useAppDispatch();
  const period = useRefreshAnalyticsPeriod();
  const { timestamp } = useAppSelector(state => state.analytics);

  return useCallback(() => {
    const timeNow = new Date().getTime();

    if (
      isNumber(timestamp) &&
      timeNow - timestamp > getMillisecondsFromDays(period)
    ) {
      dispatch(analyticsActions.refresh());
    }
  }, [dispatch, timestamp, period]);
};
